import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import { CookieService } from 'ngx-cookie-service';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;


@Component({
	selector: 'app-like-my-survey-list',
	templateUrl: './like-my-survey-list.component.html',
	styleUrls: ['./like-my-survey-list.component.css']
})
export class LikeMySurveyListComponent implements OnInit {
	surveyList: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;

	activePageNo: number = 0;
    user_id="";

	constructor(
		private commonService: CommonService,
		private authService: AuthService,
		private router: Router, 
		private pagerService: PagerService, 
		
		private activatedRoute: ActivatedRoute

		) { }

	ngOnInit() {
		
		this.commonService.process();
		$(".navbar-brand").text("My like Survey List");

		this.activatedRoute.params.subscribe((params: any) => {
			this.user_id = params.user_id;
			this.initialiseLikeActivity();
		});

	}


	initialiseLikeActivity = function () {
		this.limit = 10;
		this.pageNo = 1;
		this.getLikeActivityRepoort(this.pageNo, this.limit);
	}

	// Get survey list
	getLikeActivityRepoort = function (pageNo, limit) {

		this.commonService.process();
		

		this.authService.getlikeMySurveyList(pageNo,limit,this.user_id).subscribe(data => {

			if (data.success) {
				this.isSurveyAvailable = false;
				this.surveyList = data.userList;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;

			}else{

				this.surveyList = [];
				this.isSurveyAvailable = true;
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {

		$('.pages.active a').each(function () {
			if (parseInt($(this).text()) != page)
				$(this).parent('li').removeClass('active');
		});
		if ($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			$('#first, #prev').removeClass('disabled');
		if ($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			$('#next, #last').removeClass('disabled');

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.surveyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getLikeActivityRepoort(page, this.limit);
		}
	}

	// Search survey
	searchSurvey = function () {
		this.searchStr = $("#search").val();
		this.surveyCategory = $("#surveyCategory").val();
		this.surveyStatus = $("#surveyStatus").val();
		this.getLikeActivityRepoort(1, this.limit);
	}


}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/like-my-survey-list/like-my-survey-list.component.ts